import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Process } from '../../shared';
import { OversignTimePresenterComponent } from '../oversign-time-presenter/oversign-time-presenter.component';
import { Observable, Subscription } from 'rxjs';
import { IOversignTime } from '../IOversignTime';
import { Store, select } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import * as fromOversign from '../store/oversign-time.reducer';
import * as fromOversignA from '../store/oversign-time.actions';
import * as fromUser from '../../user-info/store/user.reducer';
import * as fromShared from '../../shared';
@Component({
    selector: 'ef-oversign-time-feature',
    templateUrl: './oversign-time-feature.component.html',
    styleUrls: ['./oversign-time-feature.component.scss'],
    standalone: false
})
export class OversignTimeFeatureComponent implements OnInit {
    public userSub: Subscription;
    process$: Observable<fromShared.Process>;
    @ViewChild(OversignTimePresenterComponent, { static: true })
    ospc: OversignTimePresenterComponent;
    public oversign$: Observable<Array<IOversignTime>>;
    public active = true;
    public employeeListID: string;

    constructor(private store: Store<fromOversign.State>) {
        this.userSub = this.store
            .pipe(
                takeWhile(_ => this.active),
                select(fromUser.getUser)
            )
            .subscribe(user => {
                if (user.userInfo) {
                    this.employeeListID = user.userInfo.EmployeeListID;
                }
            });
    }

    ngOnInit() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));

        this.store.dispatch(
            fromOversignA.getOversignTimes({
                EmployeeListID: this.employeeListID
            })
        );

        this.oversign$ = this.store.pipe(select(fromOversign.selectAll));
    }

    ngAfterViewInit() {
        this.ospc.oversignUpdate
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.store.dispatch(
                        fromOversignA.putOversignTimes({ oversignTime: value })
                    );
                }
            });
    }

    ngOnDestroy() {
        this.active = false;
    }
}
